import { useNavigate } from 'react-router-dom';
import ROUTERS from '../../../commons/constans/router';
import { ReactComponent as IconNextPageB } from '../../../assets/images/icon_nextpage_b.svg';

const Album = () => {
  const navigate = useNavigate()

  const redirectToAlbum = () => {
    navigate(ROUTERS.ALBUM)
  }
  return (
    <div className="box-album">
      <div className="box-album__header">
        <div className="flex-header">
          <div className="left">
            <h3 className="title-album">MY앨범</h3>
          </div>
          <div className="icon-album" onClick={redirectToAlbum}>
            <IconNextPageB />
          </div>
        </div>
        <p className="check-album">
          우리 아이의 사진과 영상을 확인하세요!
        </p>
      </div>
    </div>
  )
}
export default Album
